import * as React from "react";
import {
  MdDashboard,
  MdPeople,
  MdInsertDriveFile,
  MdAttachMoney,
  MdContentCopy
} from "react-icons/md";

/** Custom types */
import { NavItemType } from "../CustomTypes";

export const RootsSuperAdmin: Array<NavItemType> = [
  {
    to: "/dashboard",
    role: "ROOTS_SUPER_ADMIN",
    title: "Dashboard",
    icon: <MdDashboard size="1.3em" />
  },
  {
    to: "#",
    role: "ROOTS_SUPER_ADMIN",
    title: "Manage",
    icon: <MdPeople size="1.3em" />,
    subMenu: [
      {
        to: "/admin/team",
        title: "Admin Users"
      },
      {
        to: "/team",
        title: "Users"
      },
      {
        to: "/admin/companies",
        title: "Companies"
      }
    ]
  },
  {
    to: "/admin-reports",
    role: "ROOTS_SUPER_ADMIN",
    title: "Reports Management",
    icon: <MdInsertDriveFile size="1.3em" />
  },
  {
    to: "/admin/sales",
    role: "ROOTS_SUPER_ADMIN",
    title: "Sales",
    icon: <MdAttachMoney size="1.3em" />
  },
  {
    to: "/category-management",
    role: "ROOTS_SUPER_ADMIN",
    title: "Category Management",
    icon: <MdContentCopy size="1.3em" />
  },
  {
    to: "/interest-management",
    role: "ROOTS_SUPER_ADMIN",
    title: "Interest Management",
    icon: <MdContentCopy size="1.3em" />
  },
  {
    to: "/tags-management",
    role: "ROOTS_SUPER_ADMIN",
    title: "Tags Management",
    icon: <MdContentCopy size="1.3em" />
  }
];



// WEBPACK FOOTER //
// ./src/Navigation/RootsSuperAdminRoutes.tsx